import React from 'react';
import WidgetFrame from '../Utils/Widget/Frame/Frame.jsx';

export default class Placeholder extends React.Component {
  render() {
    return <WidgetFrame>{this.props.children}</WidgetFrame>;
  }
}
